// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1ShGf","vLegacy":"SelectSecondary_vLegacy__-HI2j","error":"SelectSecondary_error__20-Qm","disabled":"SelectSecondary_disabled__1gKKP"};